module.exports = __webpack_public_path__ + "static/media/RelishAppCenter.470df7b1.png";